export default {
  articleManagement: {
    taggingStatus: {
      filterLabel: '打标状态',
      filterPlaceholder: '请选择打标状态',
      colTitle: '标签 / 打标',
      editAction: '编辑标签',
      pending: '待打标',
      tagged: '已打标',
      toBeTagged: '待补标',
    },
    tagEdit: {
      title: '编辑文章标签',
      placeholder: '从启用标签中选择 2–4 个',
      countHint: '建议选择 {min}–{max} 个标签（已选 {count}）',
      saveOk: '标签已保存',
      loadTagsFail: '标签词表加载失败',
      loadCurrentFail: '当前标签加载失败，请重新选择',
    },
      aiReworkBtn: "AI 改写",
      submitOnlyDraft: "只有草稿状态的文章才能提交审核",
    title: '文章管理',
    addNew: '新建文章',
    createTitle: '新建文章',
    editTitle: '编辑文章',
    batchDelete: '批量删除',
    batchUpdateStatus: '批量改状态',
    batchAssignAuthor: '批量指派作者',
    confirmBatchDelete: '确定要批量删除选中的文章吗？',
    selectRows: '请先选择文章',
    status: {
      draft: '草稿',
      pending: '待审核',
      pendingReview: '待审核',
      published: '已发布',
      rejected: '已驳回',
      offline: '已下线',
    },
    source: {
      manual: '手动',
      ai: 'AI 生成',
    },
    scoreLevel: {
      excellent: '优秀',
      good: '良好',
      warning: '需优化',
      fail: '不达标',
    },
    stats: {
      total: '总计',
      draft: '草稿',
      pending: '待审核',
      published: '已发布',
      rejected: '已驳回',
      offline: '已下线',
    },
    actions: {
      viewLive: '查看线上页',
      edit: '编辑',
      aiRewrite: '🤖 AI 改写',
      preview: '预览',
      score: '评分',
      reScore: '重新评分',
      submitReview: '提交审核',
      resubmit: '重新提审',
      review: '审核',
      approve: '通过',
      reject: '驳回',
      offline: '下线',
      delete: '删除',
      returnToDraft: '退回草稿',
      confirmOffline: '确定下线该文章吗？',
      confirmDelete: '确定删除该文章吗？',
      scoreHint: '需综合评分 ≥ 70 分才能提交审核',
      submitReviewIllegal: '当前文章状态不允许提交审核，请确认文章为草稿状态',
    },
    form: {
      keyword: '文章标题',
      keywordPlaceholder: '搜索标题',
      language: '语言',
      languagePlaceholder: '请选择语言',
      category: '分类',
      categoryPlaceholder: '请选择分类',
      status: '状态',
      statusPlaceholder: '请选择状态',
      source: '来源',
      sourcePlaceholder: '请选择来源',
      author: '作者',
      authorPlaceholder: '请选择作者',
      authorFilter: '作者',
      authorFilterPlaceholder: '搜索作者姓名',
      scoreMin: '评分最低',
      scoreMax: '评分最高',
      scoreRange: '评分范围',
      dateRange: '更新时间',
      startDate: '开始日期',
      endDate: '结束日期',
      title: '标题',
      titlePlaceholder: '请输入文章标题',
      titleRequired: '请输入文章标题',
      slug: 'Slug',
      slugPlaceholder: '自动生成，可手动修改',
      tags: '标签',
      tagsPlaceholder: '逗号分隔，如：casino,guide,2025',
      articleSource: '文章来源',
      sourceManual: '人工撰写',
      sourceAI: 'AI 生成 →',
      sourceAIHint: '点击后跳转至 AI 内容生成器。在那里生成的文章将保存至文章管理。',
      scheduledPublish: '定时发布',
      scheduledTime: '发布时间',
      scheduledTimePlaceholder: '选择发布日期和时间',
      summary: '摘要',
      summaryPlaceholder: '请输入文章摘要',
      content: '正文',
      coverImage: '封面图片',
      coverImageHint: '封面图片默认同步用作 OG Image',
      keywords: '关联关键词',
      keywordsPlaceholder: '从关键词中心搜索并选择关键词',
      relatedKeywordsHint: '第一个为主关键词，其余为次要关键词',
      keywordFilter: '关联目标关键词',
      keywordFilterPlaceholder: '按关键词搜索文章',
      secondaryKeywords: '次要关键词',
      secondaryKeywordsPlaceholder: '选择次要关键词（可多选）',
      rejectReason: '驳回原因',
      rejectReasonPlaceholder: '请输入驳回原因',
      rejectReasonRequired: '请输入驳回原因',
      seoTitle: 'SEO 标题',
      seoTitlePlaceholder: '建议 50-60 字符',
      seoTitleCount: '{count} 字符',
      seoTitleWarn: '建议 50-60 字符以获得最佳 SEO 效果',
      seoDescription: 'Meta Description',
      seoDescriptionPlaceholder: '建议 100-160 字符',
      seoDescCount: '{count} 字符',
      seoDescWarn: '建议 100-160 字符以获得最佳 SEO 效果',
      canonical: 'Canonical URL',
      canonicalPlaceholder: '规范化链接',
      metaRobots: 'Meta Robots',
      ogImage: 'OG 图片',
      assignAuthor: '指派作者',
      assignAuthorPlaceholder: '请选择作者',
      targetStatus: '目标状态',
      articleType: '文章类型',
      articleTypeRequired: '请选择文章类型',
      articleTypePlaceholder: '请选择文章类型',
      languageRequired: '请选择语言',
      slugRequired: '请填写 URL Slug',
      authorRequired: '请选择作者',
      seoTitleRequired: '请填写 SEO Title',
      seoDescRequired: '请填写 Meta Description',
      ogTitle: 'OG Title',
      ogTitlePlaceholder: 'OG Title',
      ogDescription: 'OG Description',
      ogDescriptionPlaceholder: 'OG Description',
    },
    serp: {
      title: 'Google SERP 搜索结果预览',
      urlExample: 'https://yoursite.com/article',
    },
    review: {
      title: '文章审核',
      info: '文章信息',
      seoScore: 'SEO/GEO 评分',
      checkItems: '审核检查项',
      submitInfo: '提交信息',
      submittedBy: '提交人',
      submittedAt: '提交时间',
      seoInfo: 'SEO 信息',
      keywords: '关联目标关键词',
      wordCount: '字数',
      chars: '字',
      comment: '审核意见',
      commentPlaceholder: '请输入审核意见（驳回时必填）',
      commentRequired: '驳回时必须填写审核意见',
      btnReturnToDraft: '退回评分',
      btnReject: '驳回',
      btnApprove: '通过并发布',
      approveSuccess: '文章已通过审核并发布',
      rejectSuccess: '文章已驳回',
      confirmText: '确认要通过并发布该文章吗？',
      returnSuccess: '已退回草稿',
      checkHasTitle: '有标题',
      checkHasSlug: '有 Slug',
      checkHasSeoTitle: '有 SEO 标题',
      checkHasSeoDesc: '有 Meta Description',
      checkHasCover: '有封面图',
      checkHasAuthor: '有署名作者',
      checkScorePass: 'SEO 评分 ≥ 80',
      pass: '通过',
      warn: '警告',
      fail: '不通过',
    },
    batchAuthor: {
      title: '批量指派作者',
      label: '作者',
      required: '请选择作者',
      success: '作者指派成功',
      apiFail: '批量指派作者接口调用失败，请联系后端开发确认接口是否已开放',
    },
    batchDeleteApiFail: '批量删除接口调用失败，请联系后端开发确认接口是否已开放',
    batchUpdateStatusApiFail: '批量修改状态接口调用失败，请联系后端开发确认接口是否已开放',
    loadDetailFailed: '加载文章详情失败，请关闭重试，避免覆盖原内容',
    table: {
      cover: '封面',
      title: '标题',
      category: '分类',
      keywords: '关联目标关键词',
      author: '作者',
      seoScore: 'SEO',
      geoScore: 'GEO',
      totalScore: '综合评分',
      source: '来源',
      status: '状态',
      updateTime: '更新时间',
      action: '操作',
    },
    tabs: {
      basic: '基本信息',
      seo: 'SEO 设置',
    },
    saveDraft: '保存草稿',
    keywordRelSaveWarn: '文章已保存，但关键词关联保存失败——请在编辑器中重试',
    inlinkBtn: '内链推荐',
    inlinkModalTitle: '内链推荐候选',
    inlinkInjectBtn: '插入内链（{n}）',
    inlinkInjectOk: '已在正文插入 {n} 条内链，请点击「确定」保存文章后生效',
    inlinkEmpty: '未找到候选内链',
    inlinkHint: '勾选的内链会插入到正文中锚文本首次出现的位置（不含标题）。插入后请点击「确定」保存文章，否则不会生效。',
    inlinkNoneInsertable: '没有可插入的内链：候选已注入或正文中未出现锚文本',
    inlinkStatusLinked: '已注入',
    inlinkStatusMissing: '正文未出现该锚文本',
    inlinkStatusSelf: '指向当前文章',
    inlinkReasonLinked: '正文中已存在指向 {url} 的链接，无需重复插入',
    inlinkReasonMissing: '正文中未出现锚文本「{anchor}」，无法确定插入位置。可先在正文中写入该词后重新打开内链推荐，或在编辑器中手动添加链接',
    inlinkReasonNoTarget: '该候选缺少目标 URL，无法插入',
    inlinkReasonSelf: '目标是当前文章本身，不能插入自链接',
    inlinkUnsavedTip: '内链已插入正文但尚未保存，请点击「确定」保存文章，直接关闭将丢失本次插入的内链。',
    inlinkUnsavedConfirmTitle: '内链尚未保存',
    inlinkUnsavedConfirmOk: '放弃并关闭',
    inlinkUnsavedConfirmBack: '返回保存',
    viewJsonLdBtn: 'JSON-LD',
    jsonLdModalTitle: 'JSON-LD 预览（只读）',
    previewBtn: '预览',
    scoreBtn: '先评分',
    submitReviewBtn: '提交审核',
    scoreGateTooltip: '需综合评分 ≥ 70 分才能提交审核（当前：{score}）',
    openLiveTitle: '打开 H5 线上文章页',
    openAuthorTitle: '打开 H5 作者页',
    kwFilterBanner: '正在按关联关键词筛选：',
    kwFilterClear: '清除筛选',
    liveBaseUrlMissing: '站点未配置访问域名(h5BaseUrl)，暂无法打开线上页',
    liveUnavailable: '未发布，线上页不可访问',
    unsignedAuthor: '未署名',
  },

  articleTag: {
    addBtn: '新增标签',
    backfillBtn: '存量回填',
    listTitle: '标签词表',
    frm: {
      tagName: '标签名',
      tagNamePlaceholder: '搜索标签名',
      status: '状态',
      statusAll: '全部',
    },
    status: {
      enabled: '启用',
      disabled: '停用',
    },
    col: {
      tagName: '标签名',
      status: '状态',
      usageCount: '被引用文章数',
      createUser: '创建人',
      updateTime: '更新时间',
      action: '操作',
    },
    deleteConfirmTitle: '删除标签',
    deleteConfirmContent: '确定删除标签「{name}」吗？',
    deleteInUse: '该标签被文章引用，无法删除',
    deleteDisabledTip: '被引用文章数 > 0 时无法删除',
    edit: {
      createTitle: '新增标签',
      editTitle: '编辑标签',
      tagName: '标签名',
      tagNamePlaceholder: '请输入标签名',
      tagNameRequired: '请输入标签名',
      status: '状态',
      createOk: '标签已创建',
      saveOk: '标签已保存',
      duplicate: '标签名已存在',
    },
    config: {
      title: '打标模型配置',
      model: '打标模型',
      modelPlaceholder: '请选择模型',
      modelRequired: '请选择打标模型',
      modelLoadFail: '模型列表加载失败，请确认打标模型服务已部署',
      autoTagging: '启用自动打标',
      saveOk: '配置已保存',
    },
    backfill: {
      title: '存量回填',
      mode: '回填方式',
      manual: '手动逐篇',
      batch: '批量任务',
      scope: '回填范围',
      scopeToTag: '仅待打标',
      scopeAllPublished: '全部已发布',
      batchSize: '每批数量',
      limit: '本次数量上限',
      limitExtra: '仅回填「已发布且未打标」的文章，默认 200 篇',
      gotoManual: '前往文章管理',
      runBatch: '开始批量回填',
      batchOk: '批量回填任务已触发',
    },
  },

  articleType: {
    title: '文章分类管理',
    addNew: '新建分类',
    createTitle: '新建分类',
    editTitle: '编辑分类',
    seoEditTitle: '配置 SEO 模板',
    saveAndSeo: '保存并配置 SEO 模板',
    seoConfig: '配置 SEO',
    seoConfigured: '已配置',
    seoNotConfigured: '未配置',
    tplVarHint: '可用模板变量：{categoryName} {total} {currentYear} {latestUpdate}',
    actions: {
      edit: '编辑',
      seo: 'SEO 模板',
      delete: '删除',
      confirmDelete: '确定删除该分类吗？',
        confirmDeleteName: '确定删除分类「{name}」吗？',
},
    form: {
      keyword: '分类名称',
      keywordPlaceholder: '搜索分类名称',
      language: '语言',
      languagePlaceholder: '请选择语言',
      languageRequired: '请选择语言',
      isActive: '状态',
      isActivePlaceholder: '请选择状态',
      seoConfigured: 'SEO 配置',
      sortBy: '排序方式',
      sortByManual: '手动排序',
      sortByArticleCount: '文章数降序',
      sortByUpdateTime: '最近更新',
      parent: '父分类',
      parentPlaceholder: '请选择父分类（可选）',
      name: '分类名称',
      namePlaceholder: '请输入分类名称',
      nameRequired: '请输入分类名称',
      slug: 'Slug',
      slugPlaceholder: '唯一标识，URL 路径',
      slugFormat: 'Slug 仅支持小写字母、数字和连字符',
      seoKeywords: 'Meta Keywords',
      seoKeywordsPlaceholder: '逗号分隔（Google 已忽略该标签，可留空）',
      slugRequired: '请输入 Slug',
      description: '简介',
      descriptionPlaceholder: '请输入分类简介',
      descPlaceholder: '请输入分类描述（可选）',
      sortOrder: '排序',
      sortOrderPlaceholder: '数字越小越靠前',
      seoTitleTpl: 'SEO 标题模板',
      seoTitleTplPlaceholder: '如：{categoryName} 指南 {currentYear} | {total} 篇文章',
      seoDescTpl: 'Meta Description 模板',
      seoDescTplPlaceholder: '如：探索 {total} 篇 {categoryName} 文章，最新更新于 {latestUpdate}',
      schemaType: 'Schema 类型',
      schemaTypePlaceholder: '请选择 Schema 类型',
      hreflangList: 'Hreflang 关联',
      hreflangListPlaceholder: '如：en-US:/en/category/xxx,zh-CN:/zh/category/xxx',
    },
    table: {
      name: '分类名称',
      language: '语言',
      articleCount: '文章数',
      seoTemplate: 'SEO 模板',
      sortOrder: '排序',
      isActive: '状态',
      updateTime: '更新时间',
      action: '操作',
    },
    stats: {
      total: '分类总数',
      languages: '覆盖语言',
      articles: '关联文章',
      seoRate: 'SEO 完整率',
      languageUnit: '种',
      articleUnit: '篇',
      balance: '平台均衡度',
      balanceTip: '启用且有文章的分类 ÷ 分类总数，反映各分类内容是否均衡填充',
    },
    tabs: {
      basic: '基本信息',
      seoTemplate: 'SEO 模板',
    },
    schema: {
      collectionPage: 'CollectionPage（聚合内容页）',
      itemList: 'ItemList（列表页）',
    },
    seo: {
      metaDescPreviewPlaceholder: 'Meta Description 将显示在这里…',
      serpPreview: 'SERP 预览',
    },
  },

  keyWordCenter: {
    importSuccess: "导入成功 {success} 条，失败 {fail} 条",
    importEmpty: "未检测到有效数据，请检查格式",
    importLangMismatch: "行的 意图/优先级/语言 无法识别，可能导出语言与当前界面语言不一致，请切到对应语言后重试",
    exportEmpty: "当前筛选条件下没有数据",
    exportSuccess: "已导出 {count} 条关键词",
    title: '关键词情报中心',
    addNew: '新增关键词',
    createTitle: '新增关键词',
    editTitle: '编辑关键词',
    batchImport: '批量导入',
    batchDelete: '批量删除',
    confirmBatchDelete: '确定批量删除选中的关键词吗？',
    selectRows: '请先选择关键词',
    importTitle: '批量导入关键词',
    importHint: '每行一条，格式：关键词 | 意图 | 语言 | 优先级 | 月搜索量',
    importPlaceholder: '关键词 | 搜索意图 | 语言 | 优先级 | 月搜索量\nonline casino Philippines | transactional | en-US | high | 12400',
    importFormatHint: '分隔符支持逗号、竖线、Tab。也可直接上传导出的 CSV（自动识别表头，确认状态/已生成文章数/更新时间等列会忽略）。已存在的关键词会自动跳过。',
    intent: {
        informational: '信息型', info: '信息型',
        navigational: '导航型', nav: '导航型',
        transactional: '交易型', trans: '交易型',
        commercial: '商业型', comm: '商业型',
      },
    confirmStatus: {
      PENDING: '待确认',
      CONFIRMED: '已确认',
      REJECTED: '已驳回',
    },
    volumeSource: {
      gsc: 'GSC',
      dataforseo: 'DataForSEO',
      manual: '手动',
      unknown: '未知',
    },
    volumeSourceGscNote: '曝光',
    volumeStale: '陈旧',
    generate: {
      disabledNotConfirmed: '请先确认意图再生成文章',
      disabledIsTypo: 'typo 词请通过合并处理，不支持直接生成',
      disabledIsNav: '导航型关键词指向功能页，不生成文章',
    },
    confirmIntentTitle: '确认分类',
    confirmIntentDesc: '请为以下关键词确认搜索意图：',
    confirmIntentSuccess: '意图已确认',
    confirmNoEffect: '确认未生效：该词可能已被确认/驳回，或后端校验未通过，请刷新后重试',
    merge: {
      title: 'typo 词合并',
      targetKeyword: '目标词 dataPkCode',
      targetPageUrl: '目标落地页 URL',
      success: '合并成功',
    },
    priority: {
        high: '高',
        medium: '中',
        low: '低',
      },
    // 后端意图字典 intentCode → 本地化展示名（仅用于展示，传给后端的仍是 intentCode）
    intentByCode: {
      informational: '信息型', info: '信息型',
      navigational: '导航型', nav: '导航型',
      transactional: '交易型', trans: '交易型',
      commercial: '商业型', comm: '商业型',
      comparison: '对比型',
      howto: '教程型',
      localQuery: '本地查询型',
      news: '资讯型',
      question: '问答型',
    },
    coverage: {
      covered: '已覆盖',
      uncovered: '未覆盖',
    },
    actions: {
      edit: '编辑',
      generate: '生成文章',
      confirmIntent: '确认分类',
      mergeTo: '合并到',
      archive: '归档',
      restore: '恢复',
      delete: '删除',
      confirmDelete: '确定删除该关键词吗？',
      confirmArchive: '确定归档该关键词吗？',
      confirmRestore: '确定恢复该关键词吗？',
        quickConfirm: '✓ 确认',
},
    form: {
      keyword: '关键词',
      keywordPlaceholder: '搜索关键词...',
      language: '语言',
      languagePlaceholder: '请选择语言',
      intent: '搜索意图',
      intentPlaceholder: '请选择搜索意图',
      intentDictHint: '可选——由 9 类意图字典驱动，可稍后确认',
      confirmStatusPlaceholder: '确认状态',
      priority: '优先级',
      priorityPlaceholder: '请选择优先级',
      coverageStatus: '覆盖状态',
      coveragePlaceholder: '请选择覆盖状态',
      name: '关键词',
      nameRequired: '请输入关键词',
      namePlaceholder: '如：online casino Philippines',
      monthlyVolume: '月搜索量',
      monthlyVolumePlaceholder: '预估月搜索量',
      intentRequired: '请选择搜索意图',
      intentDesc: {
        info:  '用户在寻找信息或答案，如「如何选择在线赌场」',
        nav:   '用户在寻找特定网站或品牌，如「[Your Brand] 官网登录」',
        trans: '用户有明确注册或存款意向，如「赌场注册送优惠」',
        comm:  '用户在比较产品或服务，如「菲律宾最佳在线赌场排名」',
      },
      remark: '备注',
      remarkPlaceholder: '可选，补充关键词背景信息',
        volumeSource: '月搜索量来源',
    volumeSourcePlaceholder: '选择月搜索量来源',
},
    table: {
      keyword: '关键词',
      intent: '意图',
      confirmStatus: '确认状态',
      priority: '优先级',
      language: '语言',
      monthlyVolume: '月搜索量',
      coveredArticleCount: '已生成文章数',
      coverageStatus: '覆盖状态',
      relatedArticles: '关联文章',
      updateTime: '更新时间',
      articles: '篇文章',
      action: '操作',
        searchIntent: '搜索意图',
},
    stats: {
      total: '关键词总数',
      active: '启用中',
      weeklyNew: '本周新增',
      archived: '已归档',
      covered: '已覆盖文章',
      highPriority: '高优先级',
      avgVolume: '平均月搜索量',
      avgVolumeEmpty: '暂无数据',
      avgVolumeBasis: '该平均值仅由 {m} 个关键词中、{n} 个有搜索量数据的关键词算出',
      avgVolumeLowSample: '有数据的关键词太少，平均值参考价值低',
      thisWeek: '本周新增',
      coverageRate: '覆盖率',
      needCover: '需尽快覆盖',
        pendingConfirm: '高优待确认',
    generatable: '生成型（可生成）',
    coveredArticles: '已生成文章',
},
    exportCsv: '导出 CSV',
    importConfirm: '开始导入',
    importUploadText: '点击或拖拽上传 CSV 文件',
    importUploadHint: '支持 .csv 或 .txt 文件',
    selectedCount: '已选 {count} 条',
    statusActive: '活跃',
    statusArchived: '已归档',
    pleaseSelectStatus: '请选择状态',
    batchDeleteUnavailable: '关键词批量删除接口暂未开放，请联系后端开发',
    batchImportFailed: '关键词批量导入接口调用失败，请联系后端开发确认接口是否已开放',
    exportMaxLimitWarn: '数据量超过 {max} 条，仅导出前 {max} 条',
    totalRows: '共 {total} 条',
    keywordCol: '关键词',
    langDisplay: {
      'en-US': 'English',
      'zh-CN': '中文',
      'vi-VN': 'Tiếng Việt',
      'tl-PH': 'Filipino',
    },
    priorityFull: {
      high: '高优先级',
      medium: '中优先级',
      low: '低优先级',
    },
    importPreview: '预览',
    importDone: '完成',
    importConfirmWithCount: '确认（{count} 条）',
    importParsing: '解析中...',
    importParsedCount: '已解析 {count} 条',
    importReupload: '重新上传',
    importStatusCol: '导入结果',
    importSelectAll: '全选',
    importDeselectAll: '取消全选',
    importSuccessCount: '✅ 成功 {count} 条',
    importFailCount: '❌ 失败 {count} 条',
    importExistSkipHint: '已存在的关键词会自动跳过。',
    importStatusSuccess: '✅ 成功',
    miningReason: {
      duplicate: '关键词重复',
      keywordExist: '关键词已存在',
      invalidKeyword: '关键词无效',
      langNotSupported: '语言不支持',
      limitExceeded: '已达上限',
    },
    aiMining: {
      btn: 'AI 挖掘',
      title: 'AI 关键词挖掘',
      description: 'AI 会根据你输入的种子关键词，自动挖掘相关长尾词，并分析每个词的搜索意图。适合快速扩展关键词库。',
      form: {
        seed: {
          label: '种子关键词',
          extra: '输入一个核心关键词，AI 会围绕它生成变体、长尾词、问答词',
        },
        directions: {
          label: '挖掘方向',
          longTail: '长尾词变体（如 "best online casino PH 2025"）',
          qa: '问答词（如 "is online casino legal in Philippines"）',
          compare: '对比词（如 "[Your Brand] vs competitor"）',
          geo: '地域词（如 "casino Manila", "casino Cebu"）',
        },
        language: {
          label: '目标语言',
          mixed: '混合（多语言）',
        },
        competition: {
          label: '目标竞争度',
          extra: '新站建议先挖低竞争词快速获取排名',
          all: '全部竞争度',
          low: '低竞争优先（容易排名，推荐新站）',
          medium: '中竞争',
          high: '高竞争',
        },
        count: {
          label: '挖掘数量',
          fast: '10 个（快速）',
          recommended: '20 个（推荐）',
          deep: '30 个（深度）',
        },
      },
      action: {
        start: '开始 AI 挖掘',
        add: '添加到关键词中心',
        close: '关闭',
      },
      loading: 'AI 正在分析搜索意图和长尾词...',
      result: {
        title: '挖掘结果',
        note: '已自动过滤与现有关键词重复的结果。勾选想要添加的词，点击「添加到关键词中心」。',
      },
      intent: {
        informational: '信息型', info: '信息型',
        navigational: '导航型', nav: '导航型',
        transactional: '交易型', trans: '交易型',
        commercial: '商业型', comm: '商业型',
      },
      competition: {
        low: '低竞争优先（容易排名，推荐新站）',
        medium: '中竞争',
        high: '高竞争',
      },
      competitionCol: '竞争度',
      relevance: '相关度',
      selected: '已选中 {count} 个关键词',
      countUnit: '个',
      estimatedCost: '预估费用：约',
      seedRequired: '请输入种子关键词',
      directionRequired: '请至少选择 1 个挖掘方向',
      addSuccess: '成功添加 {count} 个关键词',
      selectAll: '全选',
      modelLabel: 'AI 模型',
      modelRequired: '请选择 AI 模型',
      modelPlaceholder: '请选择 AI 模型',
      addStatusCol: '添加状态',
      addStatusSuccess: '成功',
      addStatusFail: '失败',
      addResultEmptyWarn: '添加结果异常，请刷新列表确认是否已添加成功',
    },
      selectedRows: '已选中 {count} 条',
    batchConfirmUnavailable: '批量确认分类接口暂未开放',
    batchConfirmIntent: '批量确认分类',
    batchConfirmTitle: '批量确认意图',
    batchConfirmNoPending: '所选关键词中没有待确认的词',
    batchConfirmNeedIntent: '请至少为一个关键词选择意图',
    batchConfirmSuccess: '意图已批量确认',
    batchMergeTypo: '批量合并 typo',
    batchMergeNoTypo: '所选关键词中没有 typo 词',
},

  score: {
      aiReworkBtn: "AI 改写",
      submitOnlyDraft: "只有草稿状态的文章才能提交审核",
    title: 'SEO/GEO 评分器',
    checkArticle: '选择文章',
    checkArticlePlaceholder: '请选择要评分的文章',
    startScore: '开始评分',
    checkUrl: '按 URL 评分',
    checkUrlPlaceholder: '输入文章 URL',
    checkContent: '手动输入内容',
    articleTitle: '文章标题',
    articleTitlePlaceholder: '请输入文章标题',
    articleTitleRequired: '请输入文章标题',
    articleContent: '文章正文',
    articleContentPlaceholder: '请粘贴文章正文 HTML 或纯文本',
    articleContentRequired: '请输入文章正文',
    targetKeyword: '目标关键词',
    targetKeywordPlaceholder: '请输入目标关键词',
    seoDescription: 'Meta Description',
    seoDescriptionPlaceholder: '请输入 Meta Description',
    startCheck: '开始评分',
    checking: '评分中...',
    totalScore: '综合评分',
    seoScore: 'SEO 得分',
    geoScore: 'GEO 得分',
    level: {
      excellent: '可发布',
      good: '待优化',
      warning: '需优化',
      fail: '需修改',
    },
    checkItem: {
      status: {
        pass: '通过',
        warn: '警告',
        fail: '不通过',
      },
    },
    seoGroup: 'SEO 检查项',
    geoGroup: 'GEO 检查项',
    suggestion: '优化建议',
    noResult: '请先选择文章以开始评分',
    tagSuggest: '建议',
    tagTip: '提示',
    btnSubmit: '提交审核',
    btnContinue: '继续优化',
    btnEdit: '去编辑',
    btnAIRegenerate: 'AI 重新生成',
    btnRescore: '重新评分',
    btnBackToEditor: '返回编辑',
    submitTooltipNoScore: '请先跑评分',
    submitTooltipBelow80: '需综合评分 ≥ 70 才能提交审核（当前 {{score}} 分）',
    submitSuccess: '提交审核成功',
    submitFail: '提交审核失败，请重试',
    submitFailTransition: '状态流转失败，该文章当前状态不允许提交审核',
    scoreFail: '评分失败，请重试',
    scoreError: '评分请求异常，请重试',
    history: '评分历史',
    historyEmpty: '暂无评分历史',
    pleaseSelectModel: '请先选择 AI 模型',
    pleaseSelectArticle: '请先选择文章',
    selectModelLabel: '请选择 AI 模型',
    selectModelPlaceholder: '请选择 AI 模型',
    articleSearchHint: '可输入标题搜索',
    viewMore: '查看更多',
    checks: {
      titleKeyword: '标题包含目标关键词',
      metaDescLength: 'Meta Description 长度合格',
      headingStructure: 'H2/H3 标题结构完整',
      keywordDensity: '关键词密度合适',
      internalLinks: '包含站内链接',
      ogImage: 'OG 图片已配置',
      canonicalUrl: 'Canonical URL 已配置',
      faqModule: '包含 FAQ 模块',
      blufFormat: 'BLUF 格式（首句直接回答）',
      namedAuthor: '署名作者 + Person Schema',
      neutralTone: '中立权威语气',
      comparisonTable: '包含对比表格',
      authorityData: '包含权威声明与具体数据',
      freshness: '内容新鲜度',
    },
      totalScoreFormula: '综合 = (SEO + GEO 实得) / (70 + 70)',
    checkGroupMaxScore: '{{itemCount}} 项 · 满分 {{max}}',
    btnRegenWithIssues: '带问题重新生成',
    regenTooltipNoScore: '请先跑评分再使用重新生成',
    regenTooltipPassed: '当前评分已达标，可按需重新生成',
},
  aiGenerator: {
    reworkBanner: '🤖 AI 改写模式：当前改写「{title}」——生成后点「保存草稿」将直接更新原文章',
    title: 'AI 内容生成',
    cardTitle: '生成参数',
    previewTitle: '内容预览',
    historyTitle: '生成历史',
    historyCount: '最近 10 次',
    startBtn: '开始 AI 生成',
    saveDraft: '保存草稿',
    saveDraftDone: '已保存草稿',
    updateArticle: '更新文章',
    goScoreBtn: '去评分页',
    goScore: '📊 评分',
    submitReview: '📤 提交审核',
    submitReviewBtn: '提交审核',
    emptyHint: '配置参数后点击「AI 生成」',
    emptySubHint: 'AI 将生成 SEO + GEO 优化的完整文章',
    generating: 'AI 正在创作中...',

    reuseParams: '复用参数',
    viewHistory: '查看',
    historyTip: '「复用参数」：使用该次生成的关键词、长度、语气等参数重新生成。「查看」：预览之前生成的内容，可直接保存为草稿',
    form: {
      keyword: '目标关键词',
      keywordRequired: '请选择目标关键词',
      keywordPlaceholder: '从关键词中心选择...',
      customKeyword: '或直接输入关键词',
      customKeywordPlaceholder: '输入自定义关键词...',
      articleType: '文章类型',
      author: '署名作者',
      authorRequired: '请选择署名作者',
      authorPlaceholder: '选择作者...',
      coverImageSize: '封面图尺寸',
      coverImageSizeRecommended: '（推荐，OG 标准）',
      language: '语言',
      wordCount: '文章长度',
      extraReq: '补充要求',
      extraReqPlaceholder: '例如：重点突出 PAGCOR 牌照的权威性...',
      secondaryKeywords: '次要关键词（3-5）',
      secondaryKeywordsPlaceholder: '从关键词中心选择（可多选）',
      longTailQuestions: '长尾问句（3-5）',
      longTailQuestionsPlaceholder: '每行一个问句',
      aiSuggestLongTailBtn: 'AI 推荐',
      aiSuggestLongTailNoKeyword: '请先选择目标关键词',
      aiSuggestLongTailEmpty: 'AI 暂未生成问句候选，可手动输入',
      aiSuggestLongTailDisabledHint: 'AI 推荐接口暂未开放，请手动输入',
      mustInclude: '必须包含的事实',
      mustIncludePlaceholder: '文章必须包含的事实',
      mustAvoid: '必须避免',
      mustAvoidPlaceholder: '文章必须避免的词/说法',
      targetWordCount: '目标字数',
      wordsUnit: '字',
      wordCountWarning: '目标字数超出该内容类型的推荐范围',
      presetApplied: '已按所选内容类型应用默认值',
      relatedEntities: '关联实体',
      relatedEntitiesPlaceholder: '选择关联实体',
      entityTypeFilter: '实体类型',
      entityTypeFilterPlaceholder: '按类型筛选',
      entityTypePerson: '人物',
      entityTypeOrganization: '监管',
      entityTypeProduct: '游戏',
      entityTypeConcept: '概念',
      entityTypePlace: '地点',
      entityTypeBrand: '品牌',
      entityTypeEvent: '活动',
      inlinkSuggest: '内链推荐',
      inlinkSuggestBtn: '获取推荐',
      inlinkSuggestEmpty: '未找到候选文章',
      mustIncludeInlinks: '必含内链',
      entityRelSaveError: '实体关联保存失败，请重试',
      keywordIntent: {
        informational: '信息型',
        navigational: '导航型',
        transactional: '交易型',
      },
      keywordVolume: '月搜索量',
      keywordCovered: '已覆盖',
      keywordUncovered: '未覆盖',
      switchKeywordTitle: '切换目标关键词',
      switchKeywordContent: '当前正在生成中，切换关键词将中断生成。确认切换？',
      contentType: '内容类型',
      contentTypeRequired: '请选择内容类型',
      contentTypePlaceholder: '选择内容类型...',
      schemaType: 'Schema 类型',
      schemaTypePlaceholder: '选择 Schema 类型...',
      schemaTypeHint: '随内容类型自动推荐，可手动调整',
      geoMode: 'GEO 模式',
      geoModePlaceholder: '选择 GEO 模式...',
      modelCode: '文章生成模型',
      modelCodePlaceholder: '选择文章生成模型',
      modelCodeRequired: '请选择文章生成模型',
      imageModelCode: '封面图生成模型',
      imageModelCodePlaceholder: '选择封面图生成模型（可不选）',
      imageModelCodeRequired: '请选择封面图生成模型',
      imageModelCodeTip: '不选则不生成封面图，生成速度更快',
      langSimplifiedChinese: '简体中文',
      category: '文章分类',
      categoryPlaceholder: '选择文章分类（可选）',
      includeCitations: '包含引用与外链',
      includeCitationsExtra: '包含 cite 标签或外部链接，增强 GEO 权威性评分',
      includeFaq: '包含 FAQ 问答段落',
      includeFaqExtra: '包含问答式 H2，提升 GEO 答案抽取评分',
      contentLength: '文章长度',
      contentLengthShort: '短文（500-800字）',
      contentLengthStandard: '标准（1000-2000字）',
      contentLengthLong: '长文（2500-4000字）',
    },
    preview: {
      articleTitle: '文章标题',
      articleTitleRequired: '请输入文章标题',
      articleTitlePlaceholder: '请输入文章标题...',
      slug: 'URL Slug',
      slugRequired: '请输入 URL Slug',
      slugPlaceholder: '自动生成，可手动修改',
      scoreDisabledTip: '请先保存草稿',
      submitDisabledNoScore: '请先完成评分',
      submitDisabledLowScore: '评分未达到要求（需60分以上）',
      summary: '文章摘要',
      summaryPlaceholder: '2-3 句话简介...',
      ogTitle: 'OG Title',
      ogTitlePlaceholder: '默认与 SEO Title 一致',
      ogDescription: 'OG Description',
      ogDescriptionPlaceholder: '默认与 Meta Description 一致',
      coverImage: '封面图片',
      coverImageHint: '建议尺寸 1200×630px，格式 JPG/PNG/WEBP，大小不超过 2MB，同时作为 OG Image 使用。',
      aiGeneratedImage: 'AI 生成配图',
      generateCoverImage: '生成图片',
      regenerateCoverImage: '重新生成图片',
      generatingImage: '正在生成配图...',
      imageGenOk: '配图生成成功',
      imageGenEmpty: '图片生成失败，请重试',
      regenerateImage: '重新生成图片',
      regenerateImageSuccess: '图片重新生成成功',
      regenerateImageFailed: '图片生成失败，请重试',
      coverImageUploadFail: '封面图上传失败，请重试',
      noTaskForImage: '改写模式下暂不支持 AI 生成配图，请手动上传',
      selectImageModelFirst: '请先选择图片模型',
        metaDescWarnHint: '接近上限，建议适当缩短',
    metaDescOverHint: '超出 200 字符上限',
},
    articleType: {
      guide: '📖 深度指南',
      review: '⭐ 评测对比',
      news: '📰 新闻',
      faq: '❓ FAQ',
    },
    wordCount: {
      standard: '标准（1500-2000 字）',
      short: '短文（800-1200 字）',
      long: '长文（2500-3500 字）',
    },
    historyStatus: {
      draft: '草稿',
      published: '已发布',
      discarded: '已废弃',
      pending_review: '待审核',
    },
    historyCol: {
      time: '时间',
      keyword: '目标关键词',
      articleTitle: '文章标题',
      model: '模型',
      score: '评分',
      status: '状态',
      action: '操作',
        articleType: '内容类型',
},
    steps: {
      config: '配置参数',
      generate: 'AI 生成',
      preview: '编辑预览',
      score: '评分检查',
      submit: '提交审核',
    },
    genStep: {
      intent: '分析关键词与搜索意图',
      structure: '构建文章结构与 H2/H3',
      content: '撰写正文与 FAQ 段落',
      meta: '生成 SEO meta 与 OG 字段',
      image: '生成封面配图',
    },
    generatingSteps: {
      intent: '分析关键词搜索意图',
      research: '研究竞品内容结构',
      content: '生成 SEO 优化正文',
      faq: '创建 FAQ 问答对',
      meta: '生成 Meta 标签',
      links: '推荐站内链接',
    },
    geoSectionTitle: '🧠 GEO 优化选项',
    generateError: '生成失败',
    generateErrorFallback: 'AI 生成失败，请稍后重试',
    retryBtn: '重试',
    articleTypeOpt: {
      deepGuide: '📖 深度指南',
      review:    '⭐ 评测对比',
      news:      '📰 新闻',
      faq:       '❓ FAQ',
      tutorialGuide: '🎓 教程',
      howto: '🎯 玩法教程',
      comparison: '⭐ 评测对比',
      listicle: '📋 清单盘点',
      landingPage: '🛬 落地页',
      brand:     '品牌',
      brandTypo: '品牌拼写错误',
      nav:       '导航',
      trust:     '🛡️ 信任/合法性',
      tutorial:  '教学',
      local:     '📍 本地落地页',
      product:   '🎰 产品/游戏页',
      event:     '🎁 促销活动',
      info:      '信息',
    },
    geoModeOpt: {
      normal:           '普通模式',
      normalDesc:       '标准文章结构，适合大多数内容场景',
      bluf:             'BLUF 格式（推荐）',
      blufDesc:         '结论前置，开篇即给答案，AI 搜索引擎更易抽取摘要',
      compareTable:     '对比表格',
      compareTableDesc: '以表格形式呈现多方案对比，适合产品评测、方案选型类文章',
      qaCluster:        'Q&A 问答簇',
      qaClusterDesc:    '以问答对的形式组织内容',
      stepByStep:       'Step-by-step 分步',
      stepByStepDesc:   '编号分步说明，适合教程 / how-to',
      notReady: '后端暂未支持该模式，开放后可选',
    },
    stepName: {
      configParams: '解析参数',
      aiGenerate:   'AI 生成',
    },
    unknownStatus: '未知状态 {code}，请联系管理员',
    pollingTimeout: '生成超时，已停止轮询，请刷新页面后重试',
    cancelTaskBtn: '取消任务',
    deleteTaskBtn: '删除',
    runScoreCheckBtn: '跑评分',
    finalizeBtn: '发布完成',
    taskHistoryTab: 'AI 生成任务',
    publishedArticlesTab: '已发布文章',
    taskStatus: {
      created: '已创建',
      generating: '生成中',
      editing: '待编辑',
      reviewing: '审核中',
      failed: '生成失败',
      cancelled: '已取消',
      finalized: '已完成',
      unknown: '未知状态',
    },
    phase: {
      created: '待生成',
      generating: '生成中',
      editing: '已生成',
      reviewing: '待审核',
      finalized: '已终结',
      failed: '生成失败',
      cancelled: '已取消',
      unknown: '未知',
    },
    msg: {
      saveDraftOk: '已保存为草稿，可在文章管理中找到',
      saveDraftFirst: '请先保存草稿，再提交审核',
      submitReviewConfirmTitle: '提交审核',
      submitReviewConfirmContent: '确认将本文提交审核吗？',
      submitReviewDisabledHint: '综合评分达标后才能提交审核',
      scoreFirst: '请先完成 SEO/GEO 评分（≥80 分），再提交审核',
      submitReviewOk: '已成功提交审核',
      viewPending: '查看历史生成内容（待对接接口）',
      reuseOk: '已复用参数，请重新配置并生成',
      submitReviewFieldsMissing: '提交审核失败：字段不完整，请检查标题和正文',
      pkCodeLookupFailed: '任务创建成功但未能定位任务 ID，请刷新页面后重试',
      articleIdMissing: '文章已保存，但未获取到文章 ID，请刷新后继续编辑',
      cancelOk: '任务已取消',
      deleteOk: '任务已删除',
      finalizeOk: '已完成，可在文章管理中查看',
      cancelConfirmTitle: '确认取消此生成任务？',
      deleteConfirmTitle: '确认删除此生成任务？此操作不可恢复',
      scoreCheckStarted: '评分检查已启动',
      contentSyncFailed: '内容同步失败，请手动保存',
      statusTransitionIllegal: '当前状态不支持此操作',
      noTaskForSubmit: '未关联生成任务，请通过 AI 生成文章后再提交审核',
    },
  },
  siteLink: {
    title: '站内链接管理',
    addBtn: '新增规则',
    cardTitle: '站内链接规则',
    tip: '链接在 SSR 渲染时自动注入。不会对正文中已有的手动链接重复处理。目标 URL 页面下线时规则自动暂停。',
    deleteOk: '规则已删除',
    offlineTip: '目标已下线',
    hitCountLabel: '命中 {n} 篇',
    stat: {
      total: '规则总数',
      enabledRules: '启用规则',
      hitArticles: '已命中文章',
      totalHits: '累计命中链接',
    },
    col: {
      ruleName: '规则名称',
      keyword: '关键词',
      targetUrl: '目标 URL',
      lang: '语言',
      hitArticles: '命中文章数',
      lastHit: '最近触发',
      status: '状态',
      action: '操作',
    },
    drawer: {
      title: '命中详情',
      articleId: '文章 ID',
      hitCount: '命中次数',
      lastHit: '最近命中',
      action: '操作',
      viewArticle: '查看文章',
      empty: '该规则尚未命中任何文章',
    },
    statusLabel: {
      enabled: '启用',
      disabled: '暂停',
    },
    edit: {
      createTitle: '新增站内链接规则',
      editTitle: '编辑站内链接规则',
      ruleName: '规则名称',
      ruleNameRequired: '请输入规则名称',
      ruleNamePlaceholder: '例如：PAGCOR license 引导链接',
      lang: '语言',
      langRequired: '请选择语言',
      langPlaceholder: '选择语言',
      sourcePattern: '触发关键词/Pattern',
      sourcePatternRequired: '请输入触发关键词或 Pattern',
      sourcePatternPlaceholder: '例如：PAGCOR license',
      keywordExtra: '文章正文中出现这个关键词时，自动变成链接。不区分大小写。',
      targetUrl: '目标 URL',
      targetUrlRequired: '请输入目标 URL',
      targetUrlPlaceholder: '例如：/article/pagcor-casino-guide',
      targetUrlExtra: '只能是站内 URL，以 / 开头',
      anchorText: '锚文本',
      anchorTextPlaceholder: '默认使用关键词本身',
      matchType: '匹配方式',
      matchTypeExtra: '精确匹配：只匹配完全相同的词。包含匹配：只要出现该词即触发。正则匹配：使用正则表达式。',
      exactMatch: '精确匹配 — 仅匹配完全相同的词（默认推荐）',
      containsMatch: '包含匹配 — 文本中含有该词即触发',
      regexMatch: '正则匹配 — 使用正则表达式',
      maxPerPage: '单页最大替换次数',
      maxLinksExtra: '同一篇文章中同一关键词最多生成几个链接，通常设 1 就够了',
      priority: '优先级',
      priorityTooltip: '优先级越高（数字越大），规则越先被匹配。当多条规则的关键词有重叠时，优先级高的规则会先生效。建议长词/精确词设置更高优先级。',
      status: '状态',
      statusEnabled: '启用',
      statusDisabled: '暂停',
      saveOk: '规则已更新',
      createOk: '规则已创建',
      regexConfirmTitle: '使用正则匹配？',
      regexConfirmContent: '正则配置错误可能导致页面渲染异常，请确认你了解正则语法。',
      lockedTooltip: '如需修改语言或匹配方式，请删除规则后重新创建',
      applyScopeWarning: '此规则将对所选语言下的所有已发布文章生效，目前不支持指定分类或排除文章',
      advancedSettings: '高级设置',
      priorityHigh: '高（优先匹配）',
      priorityMedium: '中（默认）',
      priorityLow: '低',
      articlePickerLabel: '从已发布文章选择 (可选)',
      articlePickerPlaceholder: '搜索文章标题',
      articlePickerNeedLang: '请先选择语言',
      articlePickerExtra: '选中后自动填入上方目标 URL',
      conflictTitle: '检测到关键词冲突',
      conflictDesc: '以下已有规则的关键词与新规则存在包含关系，匹配时优先级高的会胜出。是否继续？',
    },
    frm: {
      keyword: '关键词',
      keywordPlaceholder: '搜索关键词或 URL...',
      ruleName: '规则名称',
      ruleNamePlaceholder: '搜索规则名称...',
      status: '状态',
      statusAll: '全部状态',
      lang: '语言',
      langPlaceholder: '全部语言',
    },
      deleteConfirmTitle: '确认删除？',
    deleteConfirmContent: '此操作不可撤销。删除后相关数据将被永久移除，且无法恢复。',
    deleteConfirmOk: '确认删除',
},
  siteMap: {
    status: {
      included: '已收录',
      waiting: '等待中',
      excluded: '已排除',
    },
    title: 'Sitemap 管理',
    regenBtn: '重新生成',
    viewXmlBtn: '查看 XML',
    viewAuthorsXmlBtn: '作者 XML',
    authorsXmlPending: '后端接口待接入',
    syncAuthorTip: '同步作者页进 sitemap 后预览 XML',
    syncAuthorOk: '作者页已同步',
    regenOk: 'Sitemap 已重新生成',
    cardTitle: '路径收录配置',
    xmlModalTitle: 'sitemap.xml 预览',
    toggleFail: '操作失败，已恢复',
    addBtn: '新增 URL',
    xmlEmpty: '请点击「查看 XML」生成',
    xmlLoading: '生成中…',
    frm: {
      pageType: '页面类型',
      lang: '语言',
      localIndexStatus: '收录状态',
    },
    col: {
      path: '路径模式',
      pageUrl: '页面 URL',
      type: '类型',
      pageType: '页面类型',
      lang: '语言',
      include: '收录',
      localIndexStatus: '收录状态',
      changefreq: '更新频率',
      priority: '权重',
      action: '操作',
    },
    edit: {
      titleNew: '新增 Sitemap URL',
      titleEdit: '编辑 Sitemap URL',
      pageTypeRequired: '请选择页面类型',
      pageTypePlaceholder: '选择页面类型',
      pageUrlRequired: '请输入页面 URL',
      pageUrlInvalid: '请输入有效的 URL（如 /article/slug 或 https://example.com/page）',
      pageUrlPlaceholder: '/article/my-slug 或 https://example.com/page',
      langRequired: '请选择语言',
      langPlaceholder: '选择语言',
      includeInSitemap: '纳入 sitemap.xml',
      includeInSitemapHint: '仅 included 状态的页面会输出到 sitemap.xml',
    },
    stat: {
      total: '收录页面数',
      indexed: '已索引',
      pending: '等待索引',
      excluded: '主动排除',
    },
    pageType: {
      home:     '首页',
      article:  '文章',
      category: '分类页',
      login:    '登录页',
      author:   '作者页',
      template: '模板页',
    },
    freq: {
      always: '始终',
      hourly: '每小时',
      daily: '每天',
      weekly: '每周',
      monthly: '每月',
      yearly: '每年',
      never: '从不',
    },
    xmlModal: {
      urlLabel: 'URL：',
      copyBtn: '复制',
      copyOk: '已复制到剪贴板',
      indexFileLabel: '{file}（sitemap index · 汇总各语言子 sitemap）',
      langFileLabel: '{file}（{lang} 子 sitemap）',
      copyFail: '复制失败',
      lastGenLabel: '最后生成：',
      openNewTab: '在新窗口打开 /sitemap.xml',
      closeBtn: '关闭',
    },
    statDesc: {
      title: '统计指标说明',
      total: 'SSR 服务器实际生成的 sitemap URL 总数，含所有启用路径模式。',
      indexed: '来自 Google Search Console API，每日同步，表示已被 Google 索引的页面数。',
      pending: '收录页面数减去已索引的差值，即提交但尚未被 Google 处理的页面。',
      excluded: '来自 Google Search Console，被 noindex 标签或 robots 规则排除的页面。',
      gscTip: '已索引和主动排除数据依赖 Google Search Console API 接入。未接入时显示 —。',
    },
  },
  declDoc: {
    title: '站点声明文件',
    robotsTab: 'robots.txt',
    llmsTab: 'llms.txt',
    save: '保存',
    saveOk: '保存成功',
    saveFailed: '保存失败',
    publish: '发布',
    publishOk: '发布成功',
    publishFailed: '发布失败',
    robotsDesc: '控制搜索引擎和 AI 爬虫对网站的访问权限。使用右侧开关快捷控制 AI 爬虫，无需手动编辑。',
    advancedWarn: '⚠️ 高级模式：错误的 robots 规则可能导致整站被屏蔽，保存前请确认语法正确。',
    llmsDesc: '面向 AI 的网站说明文件。告诉 AI 引擎你的网站定位、核心内容和引用方式。',
    botSwitchTitle: 'AI 爬虫快捷开关',
    botTip: '💡 做 GEO 需要允许 AI 爬虫访问。关闭后该 AI 搜索引擎将无法引用你的文章。',
    siteUrlInvalid: '请输入有效的网站域名（如 https://example.com）',
    siteUrlLabel: '网站域名',
    siteUrlHint: '此域名将用于 robots.txt 的 Sitemap 行和 llms.txt 的文章 URL，两个 tab 共享',
    brandNameLabel: '品牌名',
    brandNamePlaceholder: '如 [Your Brand]',
    taglineLabel: '一句话标语',
    taglinePlaceholder: '如 PAGCOR licensed online casino',
    statusPublished: '已发布',
    statusDraft: '草稿',
    saveAndPublish: '保存并发布',
    robotsInfoBanner: '通过开关控制 AI 爬虫抓取权限，保存并发布后写入 robots.txt 生效',
    brandIntroLabel: '品牌简介',
    brandIntroPlaceholder: '2-3 句话介绍你的品牌定位、合规资质、核心服务',
    guidesAutoTitle: 'Guides 区（自动生成 · 来自该语言已发布文章）',
    guidesEmpty: '暂无已发布的{lang}文章',
    guidesLangName: { 'en-US': '英文', 'zh-CN': '中文', 'vi-VN': '越南文', 'tl-PH': '菲律宾文' },
    guidesError: '文章列表加载失败',
    previewTitle: '实时预览',
    langLoadFail: '语言列表加载失败（可能是跨模块权限问题），已退化为默认语言，请联系后端确认「多语言多币种管理」接口权限',
      historyBtn: '版本历史',
    historyDrawerTitle: '版本历史',
    historyColVersion: '版本',
    historyColStatus: '状态',
    historyColTime: '时间',
    historyColAction: '操作',
    historyEmpty: '暂无版本记录',
    historyLoadFailed: '加载历史版本失败',
    historyNoContent: '（无内容）',
    rollbackBtn: '回滚',
    rollbackConfirmTitle: '确认回滚',
    rollbackConfirmContent: '将把所选版本恢复为新草稿，确定继续？',
    rollbackConfirmOk: '确认',
    rollbackConfirmCancel: '取消',
    rollbackOk: '回滚成功',
    rollbackFailed: '回滚失败',
    llmsInfoBanner: 'llms.txt 帮助 AI 爬虫理解你的品牌，并在 AI 搜索结果中准确引用你的内容。',
},
  health: {
    title: 'SEO 健康检查',
    rescanBtn: '🔄 重新扫描',
    scanNowBtn: '立即扫描',
    emptyHint: '暂无快照数据，请运行首次扫描',
    scanOk: '扫描完成，分数：',
    scanFailed: '扫描失败',
    scanResultEmpty: '扫描结果暂无数据，请稍后重试',
    loadFailed: '加载失败',
    resolveOk: '已标记为已解决',
    resolveFailed: '操作失败',
    scanTimeLabel: '上次扫描',
    contentFreshnessLabel: '内容新鲜度',
    authorCoverageLabel: '作者覆盖',
    schemaLabel: 'Schema 覆盖',
    crawlerAccessLabel: '爬虫可访问性',
    severityHigh: '高',
    severityMedium: '中',
    severityLow: '低',
    resolvedTag: '已解决',
    allHealthy: '所有检查通过 🎉',
    noIssues: '该项暂无问题',
    staleCard: '内容新鲜度',
    staleCount: '项过期',
    staleDesc: 'AI 引用偏好 <13 周的内容。超过 90 天未更新的文章需要刷新。',
    staleModalTitle: '过期文章列表',
    staleModalClose: '关闭',
    authorCard: '作者覆盖',
    authorDesc: 'E-E-A-T 要求：每篇文章需署名作者 + Person Schema。',
    authorManageBtn: '管理作者 >',
    unsignedViewBtn: '查看未署名文章 >',
    unsignedModalTitle: '未署名已发布文章',
    unsignedAssignBtn: '补署名',
    unsignedEmpty: '所有已发布文章均有作者',
    schemaCard: 'Schema 覆盖',
    schemaDesc: 'SSR 自动注入结构化数据，需关注缺少作者信息的文章。',
    cwvCard: 'Core Web Vitals',
    cwvDesc: '数据来源：Google PageSpeed Insights (PSI)，过去 28 天真实用户数据。',
    cwvWaitingPsi: 'PSI 数据源待接通',
    col: {
      target: '目标',
      severity: '严重等级',
      action: '操作',
      articleTitle: '文章标题',
      publishTime: '发布时间',
    },
    actionEdit: '编辑',
    actionAiRefresh: 'AI 刷新',
    actionMarkResolved: '标记已解决',
    cwv: {
      lcp: 'LCP（最大内容绘制）',
      inp: 'INP（交互到下一帧）',
      cls: 'CLS（累积布局偏移）',
      lcpHint: '良好 < 2.5s',
      inpHint: '良好 < 200ms',
      clsHint: '良好 < 0.1',
      ratingGood: '良好',
      ratingNeedsImprovement: '需改进',
      ratingPoor: '较差',
      ratingUnknown: '—',
    },
      actionReopen: '重新打开',
    reopenOk: '已重新打开',
    reopenFailed: '操作失败',
    schemaModalTitle: 'Schema 覆盖问题',
    showResolved: '显示已解决',
},
  pageModel: {
    pageType: {
      home: '首页',
      login: '登录页',
      news: '文章列表页',
      'news-category': '文章分类页',
      loading: '落地页',
      'authors-list': '作者列表页',
    },
    title: '页面 SEO 模板',
    addBtn: '＋ 新建页面 SEO',
    cardTitle: '页面 SEO 模板',
    alertTip: '管理首页、VIP、促销等固定页面的 SEO Meta 信息。每个页面按语言独立配置；文章页 SEO 在「文章管理」中单独配置。',
    allConfiguredTip: '所有固定页面已配置',
    notSet: '未设置',
    ogMissing: '缺 OG',
    missingDesc: '缺 Description',
    editBtn: '编辑',
    deleteBtn: '删除',
    deleteConfirm: '确定要删除该模板吗？',
    deleteOk: '删除成功。',
    deleteError: '删除失败，请重试。',
    loadError: '数据加载失败，请重试。',
    emptyText: '暂无页面 SEO 配置',
    toggleError: '状态切换失败，已回滚。',
    frm: {
      keyword: '搜索',
      keywordPlaceholder: '搜索页面名称',
      pageKey: 'Page Key',
      pageKeyPlaceholder: '搜索 Page Key（slug）',
      language: '语言',
      languagePlaceholder: '请选择语言',
      pageType: '页面类型',
      pageTypePlaceholder: '请选择页面类型',
      status: '状态',
      statusPlaceholder: '请选择状态',
      statusEnabled: '已启用',
      statusDisabled: '已停用',
    },
    col: {
      pageName: '页面名称',
      pageKey: 'Page Key',
      language: '语言',
      titleDesc: 'SEO Title / Description',
      og: 'OG',
      robots: 'Robots',
      enabled: '启用',
      action: '操作',
    },
    edit: {
      createTitle: '新建页面 SEO 模板',
      editTitlePrefix: '编辑页面 SEO — ',
      pageType: '页面类型',
      pageTypeRequired: '请选择页面类型',
      pageTypePlaceholder: '请选择页面类型',
      pageTypeExtra: '创建后不可修改',
      language: '语言',
      languageExtra: '创建后不可修改',
      seoTitle: 'SEO Title',
      seoTitleExtra: '推荐 50-60 字符，支持变量：{platform} {currentYear}',
      seoTitlePlaceholder: '请输入搜索结果中展示的 SEO 标题',
      seoTitleRequired: '请输入 SEO Title',
      metaDesc: 'Meta Description',
      metaDescExtra: '推荐 100-160 字符',
      metaDescPlaceholder: '请输入搜索结果中展示的 Meta 描述',
      metaDescRequired: '请输入 Meta Description',
      canonical: 'Canonical URL',
      canonicalPlaceholder: 'https://example.com',
      canonicalExtra: "规范化 URL。SSR 自动注入 <link rel='canonical'>",
      canonicalInvalid: '请输入合法的 URL（如 https://example.com）',
      pageName: '页面显示名称',
      pageNameRequired: '请输入页面显示名称',
      pageNamePlaceholder: '如：首页、VIP、促销',
      langRequired: '请选择语言',
      metaKeywords: 'Meta Keywords',
      metaKeywordsPlaceholder: '多个关键词用逗号分隔',
      loadError: '加载模板数据失败。',
      ogSync: '同步 SEO Title / Description',
      ogTitle: 'OG Title',
      ogTitlePlaceholder: '留空使用 SEO Title',
      ogDesc: 'OG Description',
      ogDescPlaceholder: '留空使用 Meta Description',
      ogSection: '社交分享 (Open Graph)',
      ogImage: 'OG 图片',
      ogImagePlaceholder: 'https://yoursite.com/og-image.jpg',
      ogImageExtra: '建议尺寸 1200×630，展示在 Facebook / Twitter / LinkedIn 分享卡片',
      ogUploadText: '上传 OG 图',
      serpPreviewTitle: 'Google SERP 预览',
      serpPreviewHint: '实时预览，Google 实际展示可能略有差异。',
      cancel: '取消',
      save: '保存',
      saveOk: 'SEO 模板已更新',
      createOk: 'SEO 模板已创建',
      saveError: '保存失败，请重试。',
      enabled: '状态',
      enabledOn: '启用',
      enabledOff: '停用',
    },
      ogComplete: '完整',
},
  author: {
    titleAdd: '新增作者',
    titleEdit: '编辑作者',
    addBtn: '新增作者',
    viewAuthorPage: '查看作者页',
    viewAuthorPageUnavailable: '站点未配置访问域名(h5BaseUrl)，暂无法打开作者页',
    col: {
      avatar: '头像',
      displayName: '展示名',
      slug: 'Slug',
      jobTitle: '职位',
      socials: '社交',
      articleCount: '文章数',
      status: '状态',
      createTime: '创建时间',
      authorPage: '作者页',
      action: '操作',
        expertiseTags: '专长领域',
    redditNoSameAs: 'Reddit 不进 sameAs（按运营 SOP）',
},
    form: {
      displayName: '展示名',
      displayNameRequired: '请输入展示名',
      displayNamePlaceholder: '请输入作者展示名',
      slug: 'Slug（作者页 URL）',
      slugRequired: '请输入 slug',
      slugFormat: 'slug 须为全小写英文与连字符（kebab-case）',
      slugTaken: '该 slug 已被占用，请换一个',
      slugPlaceholder: '如 jomar-dela-cruz（全小写英文与连字符）',
      jobTitle: '职位',
      jobTitleRequired: '请输入职位',
      jobTitlePlaceholder: '如 Senior Content Editor',
      location: '地点',
      expertiseTags: '专长标签（3-5 个，knowsAbout）',
      expertiseTagsTip: '输入后回车添加',
      quoteHighlight: '引言高亮',
      quoteHighlightPlaceholder: '作者标志性引言（展示于作者页）',
      joinedAt: '加入日期',
      avatar: '头像（≥400px）',
      uploadAvatar: '上传头像',
      bio: '简介',
      bioPlaceholder: '请输入作者简介',
      socials: '社交账号（LinkedIn 必填）',
      linkedinRequired: 'LinkedIn 必填，不可删除',
      addSocial: '添加社交账号',
      platform: '平台',
      handle: 'handle',
      url: 'URL',
      sameAs: 'sameAs',
      exclude: '排除',
      status: '状态',
      enabled: '启用',
      disabled: '停用',
        editorialApproach: '编辑准则',
    editorialApproachPlaceholder: '描述该作者的写作风格与编辑标准',
    previewSchema: '预览 Person Schema（JSON-LD）',
},
    frm: {
      displayNamePlaceholder: '展示名搜索',
      jobTitlePlaceholder: '职位搜索',
      statusPlaceholder: '请选择状态',
    },
    msg: {
      createOk: '创建成功',
      updateOk: '更新成功',
      socialsSaveWarn: '作者已保存，但社交账号保存失败，请重新编辑保存',
      operateFail: '操作失败',
      linkedinRequired: 'LinkedIn 为必填社交账号（需填 URL）',
      avatarFormat: '仅支持 JPG/PNG/WEBP 格式',
      avatarMaxSize: '图片大小不能超过 2MB',
      avatarTooSmall: '头像尺寸需 ≥400×400px',
      urlInvalid: '请输入有效的 URL（以 http:// 或 https:// 开头）',
      deleteConfirm: '确认删除该作者吗？',
      view: '查看',
        schemaSaveFirst: '请先保存作者，再预览 Person Schema。',
    schemaLoadFail: 'Person Schema 预览加载失败。',
},
      infoBanner: '作者档案越完整（职位 + 专长 + LinkedIn），生成的 Person schema 越强，越利于 AI 引擎将其识别为领域权威作者。',
      infoBannerTitle: '作者档案影响 Person Schema 质量',
},
  siteBaseUrl: {
    title: '站点域名配置 (h5BaseUrl)',
    declModeTip: '存于站点声明文件（fileType=siteConfig）。保存即发布新版本，H5 SSR 读取最新已发布值。',
    currentPublished: '当前已发布',
    publishBtn: '保存并发布',
    publishOk: '已发布',
    addBtn: '新增配置',
    notReady: '后端未就绪',
    notReadyTip: '站点配置接口尚未实现（Taylor 契约无此域），所有写操作已禁用。',
    col: {
      platform: '平台',
      env: '环境',
      h5BaseUrl: 'H5 域名根',
      remark: '备注',
      updateTime: '更新时间',
      action: '操作',
    },
    edit: {
      titleNew: '新增站点配置',
      titleEdit: '编辑站点配置',
      platformRequired: '请输入平台标识',
      envRequired: '请选择环境',
      envPlaceholder: '选择环境',
      h5BaseUrlRequired: '请输入 H5 域名根',
      h5BaseUrlInvalid: '请输入以 http(s):// 开头的合法 URL',
      h5BaseUrlTip: '不带结尾 /，如 https://www.fbmplay.com',
    },
  },
};
